import { createIcon } from './icon';

export const StarIcon = createIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 14.3917L15.15 17.5L13.7833 11.6417L18.3333 7.7L12.3417 7.19167L10 1.66667L7.65833 7.19167L1.66667 7.7L6.21667 11.6417L4.85 17.5L10 14.3917Z"
      fill="currentColor"
    />
  </svg>,
  'StarIcon'
);
